import React, { useEffect, useState } from "react";

import Header from "../layout/Header";
import "./index.scss";
import projet1 from "../../assets/slideP1.png";
import projet2 from "../../assets/projet2.png";
import projet3 from "../../assets/projet3.png";
import rightArrow from "../../assets/btn-next.png";
import leftArrow from "../../assets/btn-suiv.png";

const SlideApropo = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const images = [
    {
      id: 1,
      src: projet1,
      alt: "Grande Image",
      title: "Zoom sur nos Projets en Afrique : Ce Qui Se Passe en Ce Moment",
      date: "12/23/2024",
    },
    {
      id: 2,
      src: projet2,
      alt: "Petite Image 1",
      title: "Nos Avancées et Résultats Concrets",
      date: "12/25/2024",
    },
    {
      id: 3,
      src: projet3,
      alt: "Petite Image 2",
      title: "Nouveaux Partenariats et Collaborations",
      date: "12/25/2024",
    }, // Exemple d'image 1
  ];

  const handlePrev = () => {
    setActiveIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };
 
  
  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
  };
  return (
    <div className="slide-apropo">
      <Header />
      <div className="slide-apropo-container ">
        <div className="row w-100">
          <div className="col-lg-5">
            <div className="slide-apropo-container-content ">
              <h1 className="slide-apropo-container-content-title">
                Qui sommes nous ?
              </h1>
              <p className="slide-apropo-container-content-description">
                La Fondation Junior MBUYI améliore les conditions de vie en
                milieu rural en fournissant vivres et infrastructures. Elle
                redonne espoir, dignité et autonomie aux populations souvent
                oubliées.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className=" slide-apropo-card">
              <div className="card">
                <h5 className="card-title">Découvrir nos Projets</h5>
                <div className="carousel">
                  {/* Carrousel d'images */}
                  <div className="d-flex justify-content-center">
                    <button onClick={handlePrev} className="btn-prev">
                      <img
                        src={leftArrow}
                        alt="Précédent"
                        className="arrow-icon"
                      />
                    </button>
                    <div className="carousel-inner">
                      <div className="carousel-text-on-image">
                        <h2>{images[activeIndex].title}</h2>
                        <p>{images[activeIndex].date}</p>
                      </div>
                      <img
                        src={images[activeIndex].src}
                        alt={`Image ${activeIndex + 1}`}
                        className="carousel-image"
                      />
                    </div>

                    <button onClick={handleNext} className="btn-next">
                      <img
                        src={rightArrow}
                        alt="Suivant"
                        className="arrow-icon"
                      />
                    </button>
                  </div>
                  {/* Indicateurs d'index */}
                  <div className="carousel-controls">
                    <div className="indicators">
                      {images.map((_, index) => (
                        <div
                          key={index}
                          className={`indicator ${index === activeIndex ? "active" : ""}`}
                          onClick={() => setActiveIndex(index)}
                        />
                      ))}

                      {/* Boutons de navigation */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Section */}
    </div>
  );
};

export default SlideApropo;
